<div class="container">
    <div class="row justify-content-center">
        <div class="col-lg-6 col-sm-12 mx-auto">
            <div class="mt-3">
                <img style=" width: 30%" src="assets/img/newLogo.png">
            </div>
            <div class="my-4">
              
                <form>
                    <div class="row mt-5 align-items-center">
                      
                        <div class="col">
                            <div class="row align-items-center">
                                <div class="col-md-7">
                                    <h4 class="mb-1 whit ">Brown, Asher</h4>
                                    <p class="small mb-3 whit "><span class="badge badge-dark">New York, USA</span></p>
                                </div>
                            </div>
                            <div class="row mb-4">
                               
                                <div class="col">
                                    <p class="small mb-0 text-muted whit ">Nec Urna Suscipit Ltd</p>
                                    <p class="small mb-0 text-muted whit ">P.O. Box 464, 5975 Eget Avenue</p>
                                    <p class="small mb-0 text-muted whit ">(537) 315-1481</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="my-4" />
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="firstname">Firstname</label>
                            <input type="text" id="firstname" class="form-control" placeholder="Brown" />
                        </div>
                        <div class="form-group col-md-6">
                            <label for="lastname">Lastname</label>
                            <input type="text" id="lastname" class="form-control" placeholder="Asher" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="inputEmail4">Email</label>
                        <input type="email" class="form-control" id="inputEmail4" placeholder="brown@asher.me" />
                    </div>
                    <div class="form-group">
                        <label for="inputAddress5">Address</label>
                        <input type="text" class="form-control" id="inputAddress5" placeholder="P.O. Box 464, 5975 Eget Avenue" />
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="inputCompany5">Zip</label>
                            <input type="text" class="form-control" id="inputCompany5" placeholder="77123" />
                        </div>
                        <div class="form-group col-md-4">
                            <label for="inputState5">State</label>
                            <select id="inputState5" class="form-control">
                                <option selected="">{{nyState}}</option>
                                <option *ngFor="let item of states">{{item}}</option>
                            </select>
                        </div>
                       
                    </div>
                    <hr class="my-4" />
                   
                    <button type="submit" class="btn btn-primary">Save Change</button>
                </form>
            </div>
        </div>
        <div class="col-lg-6 col-sm-12  mx-auto">
          
            <div class="my-4">
              
                <form>
                    <div class="row mt-5 align-items-center">
                      
                        <div class="col">
                            <div class="row align-items-center">
                                <div class="col-md-7">
                                    <h4 class="mb-1 whit ">Brown, Asher</h4>
                                    <p class="small mb-3 whit "><span class="badge badge-dark">New York, USA</span></p>
                                </div>
                            </div>
                            <div class="row mb-4">
                               
                                <div class="col">
                                    <p class="small mb-0 text-muted whit ">Nec Urna Suscipit Ltd</p>
                                    <p class="small mb-0 text-muted whit ">P.O. Box 464, 5975 Eget Avenue</p>
                                    <p class="small mb-0 text-muted whit ">(537) 315-1481</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <hr class="my-4" />
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="firstname">Firstname</label>
                            <input type="text" id="firstname" class="form-control" placeholder="Brown" />
                        </div>
                        <div class="form-group col-md-6">
                            <label for="lastname">Lastname</label>
                            <input type="text" id="lastname" class="form-control" placeholder="Asher" />
                        </div>
                    </div>
                    <div class="form-group">
                        <label for="inputEmail4">Email</label>
                        <input type="email" class="form-control" id="inputEmail4" placeholder="brown@asher.me" />
                    </div>
                    <div class="form-group">
                        <label for="inputAddress5">Address</label>
                        <input type="text" class="form-control" id="inputAddress5" placeholder="P.O. Box 464, 5975 Eget Avenue" />
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6">
                            <label for="inputCompany5">Zip</label>
                            <input type="text" class="form-control" id="inputCompany5" placeholder="77123" />
                        </div>
                        <div class="form-group col-md-4">
                            <label for="inputState5">State</label>
                            <select id="inputState5" class="form-control">
                                <option selected="">{{nyState}}</option>
                                <option *ngFor="let item of states">{{item}}</option>
                            </select>
                        </div>
                       
                    </div>
                    <hr class="my-4" />
                   
                    <button type="submit" class="btn btn-primary">Save Change</button>
                </form>
            </div>
        </div>
    </div>
    
    </div>
